import type { Stage, StageMap } from '@/types/project'

export const STAGE_COUNT = 11

/** The Proof-of-Product stage. Kept as a stable id (11) but displayed 3rd, so
 *  existing projects' stage data (keys 1..10) is never renumbered. */
export const PROOF_STAGE_ID = 11

export interface StageDefinition {
  /** Stable stage id (also the Firestore stage key). Not the display position. */
  id: number
  name: string
}

/**
 * The fixed progress stages, in display order (spec §4.3.2). "Proof of Product"
 * (id 11) shows in position 3; the timeline numbers stages by position, so it
 * reads as step 3 while its stored key stays 11.
 */
export const STAGES: readonly StageDefinition[] = [
  { id: 1, name: 'Supplier Company Documents' },
  { id: 2, name: 'Client Company Documents' },
  { id: 11, name: 'Proof of Product' },
  { id: 3, name: 'SPA Execution' },
  { id: 4, name: 'Advance Payment or Proof of Fund' },
  { id: 5, name: 'Payment Guarantee' },
  { id: 6, name: 'Export Document' },
  { id: 7, name: 'Goods Departure' },
  { id: 8, name: 'Warehouse Delivery' },
  { id: 9, name: 'Assay Report' },
  { id: 10, name: 'Payment to Supplier' },
]

/**
 * Upload-permission matrix (spec §5.2.2 supplier, §6.2.2 client). Admin uploads
 * to every stage. This is the single source of truth mirrored by
 * firestore.rules / storage.rules and asserted by the rules tests. The supplier
 * provides the Proof of Product (stage 11).
 */
export const SUPPLIER_UPLOAD_STAGES: readonly number[] = [1, 6, 7, 8, 11]
export const CLIENT_UPLOAD_STAGES: readonly number[] = [2, 3, 4, 5, 9, 10]

/** A fresh stage map with all 10 stages Red (used when creating a project — Phase 4). */
export function initialStageMap(): StageMap {
  const map: StageMap = {}
  for (const { id } of STAGES) {
    const stage: Stage = { status: 'red', updatedAt: null, updatedBy: null }
    map[String(id)] = stage
  }
  return map
}
